import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import formatPennies from "../../../../../../helpers/format/formatPennies";
import AvatarCard from "../../../../../../components/AvatarCard";
import colors from "../../../../../../theme/colors";

const getColor = (writtenOffReserve: number): string => {
  if (writtenOffReserve > 0) {
    return colors.danger;
  }
  return colors.link;
};

interface Props {
  writtenOffReserve: number;
}

const WrittenOffReserveCard = ({
  writtenOffReserve
}: Props): JSX.Element => (
  <AvatarCard
    title="Past Written-Off Reserve"
    color={getColor(writtenOffReserve)}
    icon={<FontAwesomeIcon icon={faPen} size="lg" />}
    subheader={formatPennies(writtenOffReserve)}
  />
);

export default WrittenOffReserveCard;
